export default __webpack_public_path__ + "static/sheep-flocking-7556a25e2a7314c6eb97d0719648f860.mp4";